import React, { useEffect, useState } from 'react';

export const SvgIconContext = React.createContext({});

export const SvgIconProvider = ({ brand, children }) => {
  const [icons, setIcons] = useState({});

  useEffect(() => {
    import(`./${brand}`).then((module) => {
      setIcons(module.default);
    });
  }, [brand]);

  return (
    <SvgIconContext.Provider value={icons}>{children}</SvgIconContext.Provider>
  );
};

export default SvgIconContext;
